import * as React from "react";
const SvgIcon59 = props => <svg xmlns="http://www.w3.org/2000/svg" fill="none" width="1em" height="1em" viewBox="0 0 23.33 23.33" {...props}><defs><style /></defs><g transform="rotate(-45 0 9.86)"><circle cx={7} cy={16.9} className="icon_59_svg__cls-2" fillOpacity={0} r={7} /><circle cx={7} cy={16.9} fillOpacity={0} strokeWidth={1.67} strokeLinecap="ROUND" style={{
      stroke: "currentColor"
    }} r={6.17} /></g><rect x={6} y={22.9} width={2} height={6} rx={0} style={{
    fill: "currentColor"
  }} transform="rotate(-45 0 9.86)" /></svg>;
export default SvgIcon59;